var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarxiix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1434 9.28574L14.2863 12.1429H11.4291L8.92913 14.6429V12.1429H5.71484V1.42859H17.1434V9.28574Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00014 0L1.42871 3.57143V16.4286H5.71443V20L9.28585 16.4286H12.143L18.5716 10V0H5.00014ZM17.143 9.28571L14.2859 12.1429H11.4287L8.92871 14.6429V12.1429H5.71443V1.42857H17.143V9.28571Z",
    fill: "#9146FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0008 3.92859H13.5723V8.2143H15.0008V3.92859Z",
    fill: "#9146FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0721 3.92859H9.64355V8.2143H11.0721V3.92859Z",
    fill: "#9146FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarxiix);
export default __webpack_public_path__ + "static/media/marxiix.85a8450bbc9bb924648837b820044714.svg";
export { ForwardRef as ReactComponent };